import * as React from "react";
import Paper from "@mui/material/Paper";
import { useEffect, useState, useRef,useMemo } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  Chip,
  Divider,
  Grid,
  Modal,
  Stack,
  TextField,
  Typography,
  IconButton,
  Avatar,
  CardContent,
  CardMedia,
  CircularProgress,
  Switch,
  FormControlLabel,
  alpha,
  useTheme,
  GlobalStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from "@mui/material";
import {
  DataGrid,
  GridColDef,
  GridToolbar,
  GridActionsCellItem,
} from "@mui/x-data-grid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PrintIcon from "@mui/icons-material/Print";
import RefreshIcon from "@mui/icons-material/Refresh";
import PersonIcon from "@mui/icons-material/Person";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import api, { HOST_Live } from "../../utils/Url";
import { useTranslation } from "react-i18next";
import { getISTDate } from "../../utils/Constant";
import * as signalR from "@microsoft/signalr";
import { Dialog, DialogContent, Zoom } from "@mui/material"; // Added Dialog and Zoom
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from "@mui/icons-material/Close";
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
 
const modalStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: 700,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 3,
  maxHeight: "90vh",
  overflowY: "auto",
};

interface Visitor {
  id: number;
  mem_cd: string;
  mname: string;
  mobileNo: string;
  mem_type: string;
  mem_dept: string;
  mem_degree: string;
  mem_ctgry: string;
  iss_dt: string;
  accNo: string;
  title: string;
  recv_dt: string;
  member_photo: string;
}

interface FilterState {
  mem_cd: string;
  iss_dt: string;
  recv_dt: string;
}




export default function DropboxReturn() {
  const theme = useTheme();
  const { defaultValues } = getISTDate();
  const [topVisitors, setTopVisitors] = useState<Visitor[]>([]);
  const [filteredVisitors, setFilteredVisitors] = useState<Visitor[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isRealTime, setIsRealTime] = useState(true);
  const [selectedVisitor, setSelectedVisitor] = useState<Visitor | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [filters, setFilters] = useState<FilterState>({
    mem_cd: "",
    iss_dt: defaultValues,
    recv_dt: defaultValues
  });

  //const today = moment().format("YYYY-MM-DD");
  const today = useMemo(() => moment().format("YYYY-MM-DD"), []);
  const [memberCodeOptions, setMemberCodeOptions] = useState<any[]>([]);
  const [memberCodeLoading, setMemberCodeLoading] = useState(false);
  const [timerCheck, setTimerCheck] = useState<NodeJS.Timeout | null>(null);
  const [lastAddedId, setLastAddedId] = useState<number | null>(null);
  const gridRef = useRef<HTMLDivElement | null>(null);
  const [dropboxMessage, setDropboxMessage] = useState<string>("");
  const [dropboxType, setDropboxType] = useState<string>("");


  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState<string>(""); // insert, processing, success, failed
  const [modalMessage, setModalMessage] = useState<string>("");

  // Fetch top visitors data
  const fetchTopVisitors = async () => {
    try {
      const response = await api.post(`VisitorInfoex/GetDropBoxRerturnTop`);
      if (response.data && response.data.isSuccess) {
const todayData = response.data.data.filter((x: any) => 
                moment(x.recv_dt).format("YYYY-MM-DD") === today
);
        setTopVisitors(todayData);
        // setTopVisitors(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching top visitors:", error);
      toast.error("Failed to fetch top visitors");
    }
  };

  // Fetch filtered visitors data
  const fetchFilteredVisitors = async () => {
    try {
      const response = await api.post(`VisitorInfoex/GetDropBoxRerturn`, {
        ...filters,
        recv_dt: today,           // 🔥 Force today date
        mname: "",
        mobileNo: "",
        mem_type: "",
        mem_dept: "",
        mem_degree: "",
        mem_ctgry: "",
        accNo: "",
        title: "",
        member_photo: ""
      });
      if (response.data && response.data.isSuccess) {
        let arr = response.data.data.filter((x: any) => 
                moment(x.recv_dt).format("YYYY-MM-DD") === today
            ); 
        arr = arr.map((item: Visitor, index: number) => ({
          ...item,
          id: index + 1
        }));
        setFilteredVisitors(arr);
      }
    } catch (error) {
      console.error("Error fetching filtered visitors:", error);
      toast.error("Failed to fetch visitor data");
    } finally {
      setIsLoading(false);
    }
  };

  // Get member search results
  const getMemberSearchResults = async (searchText: string) => {
    if (!searchText || searchText.length < 1) {
      setMemberCodeOptions([{ value: "-1", label: "Type to search members" }]);
      return;
    }

    setMemberCodeLoading(true);
    try {
      const response = await api.get(`AssigningRfid/GetMember?name=${searchText}`);
      const transformedData = response?.data?.map((item: any) => ({
        value: item?.value,
        label: item?.label
      })) || [];

      setMemberCodeOptions(transformedData.length > 0
        ? transformedData
        : [{ value: "-1", label: "No members found" }]
      );
    } catch (error) {
      console.error("Error fetching members:", error);
      setMemberCodeOptions([
        { value: "-1", label: "Error fetching members" },
      ]);
    } finally {
      setMemberCodeLoading(false);
    }
  };

  // Handle input change for member code search
  const handleInputChange = (event: any) => {
    const newQuery = event.target.value;
    if (newQuery !== "") {
      if (timerCheck) {
        clearTimeout(timerCheck);
      }
      const checkResult = setTimeout(() => {
        getMemberSearchResults(newQuery);
      }, 500);
      setTimerCheck(checkResult);
    }
  };

  // Initial data fetch

  const connectionRef = useRef<signalR.HubConnection | null>(null);

  useEffect(() => {

    // 🔴 अगर switch OFF है → connection बंद
    if (!isRealTime) {
      connectionRef.current?.stop();
      console.log("SignalR Stopped ❌");
      return;
    }

    // 🟢 connection create
    const connection = new signalR.HubConnectionBuilder()
      //.withUrl("https://localhost:7465/dropBoxHub")
      .withUrl(HOST_Live)
      .withAutomaticReconnect()
      .build();

    connectionRef.current = connection;

    connection.start()
      .then(() => {
        console.log("SignalR Connected ✅");

        connection.on("ReceiveDropBoxEvent", (data: any) => {
          console.log("📥 Full SignalR Data Received:", data);

          // 1. MODAL & ANIMATION LOGIC
          // -------------------------------------------------------
          setModalType(data.type); // 'insert', 'processing', 'success', 'Failed'
          setShowModal(true);      // Always show modal when event starts

          if (data.type === "insert") {
            setModalMessage("Please insert your book into the Dropbox slot");
          }
          else if (data.type === "av") {
            setModalType("notIssued");
            setModalMessage("This book has not been issued yet.");
          }

          else if (data.type === "processing") {
            setModalMessage(`Scanning Book... ${data.accNo ? 'Acc No: ' + data.accNo : ''}`);
          }
          else if (data.type === "success") {
            const successMsg = `Successfully Returned: ${data.title || 'Book'} (Acc: ${data.accNo})`;
            setModalMessage(successMsg);
            toast.success(`${data.accNo} returned a book!`);

            // Auto-close success modal after 4 seconds
            setTimeout(() => {
              fetchTopVisitors();        // Top Card ke liye
              fetchFilteredVisitors();   // Grid ke liye
            }, 800);

            // 2. DATA UPDATES (Only on Success)
            // -------------------------------------------------------

            // Create a unique ID for the DataGrid row
            const uniqueId = Date.now();

            // Update the TOP CARD (Latest visitor)
            // We wrap data in an array because the map function expects an array
            setTopVisitors([data]);

            // Update the DATAGRID (Table)
            setFilteredVisitors((prev) => {
              // Check for duplicate (if the same book/member is already at the top of the list)
              const isDuplicate = prev.some(
                (item) => item.mem_cd === data.mem_cd && item.accNo === data.accNo
              );

              if (isDuplicate) return prev;

              // Add new record to the top of the table
              const newRecord = { ...data, id: uniqueId };
              return [newRecord, ...prev];
            });

            // 3. UI EFFECTS
            // -------------------------------------------------------

            // Set highlight for the new row
            setLastAddedId(uniqueId);

            // Play Notification Sound (Optional - uncomment to use)
            // const audio = new Audio("https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3");
            // audio.play().catch(e => console.log("Audio play blocked"));

            // Smooth Scroll the Grid to the top to see the new entry
            setTimeout(() => {
              if (gridRef.current) {
                const gridElement = gridRef.current.querySelector(".MuiDataGrid-virtualScroller");
                if (gridElement) {
                  gridElement.scrollTo({ top: 0, behavior: "smooth" });
                }
              }
            }, 100);
          }
          else if (data.type === "Failed") {
            setModalMessage(data.message || "Book return failed. The system could not verify the RFID tag.");
            toast.error("Return Failed!");
          }
        });

        connection.onclose(() => console.log("Connection Closed ❌"));
        connection.onreconnecting(() => console.log("Reconnecting..."));
        connection.onreconnected(() => console.log("Reconnected ✅"));

      })
      .catch(err => console.error(err));

    return () => {
      connection.stop();
    };

  }, [isRealTime]);

  useEffect(() => {
    setTopVisitors([]);           // पुराना data clear
    setFilteredVisitors([]);
    fetchTopVisitors();
    fetchFilteredVisitors();
  }, [today]);
  // Set up real-time updates
  // useEffect(() => {
  //   let intervalId: NodeJS.Timeout;

  //   if (isRealTime) {
  //     intervalId = setInterval(() => {
  //       fetchTopVisitors();
  //       fetchFilteredVisitors();
  //     }, 3000);
  //   }

  //   return () => {
  //     if (intervalId) clearInterval(intervalId);
  //   };
  // }, [isRealTime]);

  // Handle filter changes
  const handleFilterChange = (field: keyof FilterState, value: string) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Apply filters
  const applyFilters = () => {
    setIsLoading(true);
    fetchFilteredVisitors();
  };

  // Reset filters
  const resetFilters = () => {
    setFilters({
      mem_cd: "",
      iss_dt: defaultValues,
      recv_dt: defaultValues
    });
  };

  // Handle view action
  const handleView = (visitor: Visitor) => {
    setSelectedVisitor(visitor);
    setModalOpen(true);
  };

  // Format base64 image
  const formatBase64Image = (base64String: string) => {
    if (!base64String) return "";
    if (base64String.startsWith("data:image")) return base64String;
    return `data:image/jpeg;base64,${base64String}`;
  };

  // DataGrid columns
  const columns: GridColDef[] = [
    {
      field: "mem_cd",
      headerName: "Member Code",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "mname",
      headerName: "Member Name",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "mem_dept",
      headerName: "Department",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "mem_degree",
      headerName: "Program",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "mem_ctgry",
      headerName: "Category",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "mobileNo",
      headerName: "Mobile No",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "mem_type",
      headerName: "Member Type",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "iss_dt",
      headerName: "Issue Date",
      flex: 1,
      minWidth: 120,
      valueFormatter: (params) =>
        params.value ? moment(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: "recv_dt",
      headerName: "Receive Date",
      flex: 1,
      minWidth: 120,
      valueFormatter: (params) =>
        params.value ? moment(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<VisibilityIcon />}
          label="View"
          onClick={() => handleView(params.row)}
        />,
      ],
    },
  ];

  useEffect(() => {
    if (showModal) {
      const timer = setTimeout(() => {
        setShowModal(false);
      }, 5000); // 5 seconds

      return () => clearTimeout(timer); // cleanup
    }
  }, [showModal]);

  return (
    <>
      <ToastContainer />


      <GlobalStyles styles={{
        '@keyframes bookInsert': {
          '0%': { transform: 'translateY(-80px) rotateX(30deg) scale(1)', opacity: 0 },
          '20%': { transform: 'translateY(-40px) rotateX(15deg) scale(1.1)', opacity: 1 },
          '80%': { transform: 'translateY(30px) rotateX(-15deg) scale(0.8)', opacity: 1 },
          '100%': { transform: 'translateY(90px) rotateX(-30deg) scale(0.5)', opacity: 0 },
        },
        '@keyframes slotGlow': {
          '0%, 100%': { boxShadow: '0 0 15px rgba(25, 118, 210, 0.3), inset 0 0 10px rgba(25, 118, 210, 0.1)' },
          '50%': { boxShadow: '0 0 30px rgba(25, 118, 210, 0.6), inset 0 0 20px rgba(25, 118, 210, 0.3)' },
        },
        '@keyframes arrowMoving': {
          '0%, 100%': { transform: 'translateY(0)', opacity: 0.3 },
          '50%': { transform: 'translateY(10px)', opacity: 1 },
        }
      }} />

      {/* 2. THE INTERACTIVE DIALOG */}
      <Dialog
        open={showModal}
        TransitionComponent={Zoom}
        onClose={() => setShowModal(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 5,
            textAlign: 'center',
            p: 1,
            overflow: 'visible', // Allow icons to pop out slightly
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)'
          }
        }}
      >
        {/* Close Icon */}
        <IconButton
          onClick={() => setShowModal(false)}
          sx={{ position: 'absolute', right: 8, top: 8, color: 'grey.500' }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ mt: 2 }}>

          {/* --- VIEW 1: INSERT ANIMATION --- */}
          {modalType === "insert" && (
            <Box>
              <Typography variant="h5" fontWeight={800} color="primary" gutterBottom>
                Ready to Return
              </Typography>

              <Box sx={{ position: 'relative', height: 200, display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2 }}>
                {/* The Floating Book */}
                <Box sx={{
                  position: 'absolute',
                  top: 20,
                  animation: 'bookInsert 2.5s infinite ease-in-out',
                  color: theme.palette.primary.main
                }}>
                  <LibraryBooksIcon sx={{ fontSize: 90 }} />
                </Box>

                {/* The Slot */}
                <Box sx={{
                  position: 'absolute',
                  bottom: 20,
                  width: '180px',
                  height: '20px',
                  background: '#1a1a1a',
                  borderRadius: '4px',
                  animation: 'slotGlow 2s infinite',
                  transform: 'perspective(100px) rotateX(40deg)',
                  border: '2px solid #444'
                }} />

                <KeyboardDoubleArrowDownIcon sx={{
                  fontSize: 40,
                  color: 'primary.light',
                  animation: 'arrowMoving 1.5s infinite',
                  mt: 6
                }} />
              </Box>
            </Box>
          )}


          {modalType === "notIssued" && (
            <Box sx={{ py: 3 }}>
              <InfoOutlinedIcon
                sx={{ fontSize: 100, color: 'black', mb: 2 }}
              />

              <Typography
                variant="h5"
                fontWeight={800}
                color="black"
              >
                Not Issued
              </Typography>
            </Box>
          )}

          {/* --- VIEW 2: PROCESSING --- */}
          {/* {modalType === "processing" && (
            <Box sx={{ py: 4 }}>
              <CircularProgress size={70} thickness={4} sx={{ mb: 3 }} />
              <Typography variant="h6" fontWeight={700}>Reading RFID...</Typography>
            </Box>
          )} */}

          {/* --- VIEW 3: SUCCESS --- */}
          {modalType === "success" && (
            <Box sx={{ py: 3 }}>
              <CheckCircleOutlineIcon sx={{ fontSize: 100, color: 'success.main', mb: 2 }} />
              <Typography variant="h5" fontWeight={800} color="success.main">Success!</Typography>
            </Box>
          )}

          {/* --- VIEW 4: FAILED --- */}
          {modalType === "Failed" && (
            <Box sx={{ py: 3 }}>
              <ErrorOutlineIcon sx={{ fontSize: 100, color: 'error.main', mb: 2 }} />
              <Typography variant="h5" fontWeight={800} color="error.main">Failed</Typography>
            </Box>
          )}

          {/* THE MESSAGE (Always visible at bottom) */}
          <Typography
            variant="body1"
            sx={{
              mt: 3,
              px: 2,
              fontWeight: 800,
              fontSize: '1.3rem',

              color: '#d32f2f',

              animation: 'blinkText 1s infinite'
              ,

              '@keyframes blinkText': {
                '0%': { opacity: 1 },
                '50%': { opacity: 0.2 },
                '100%': { opacity: 1 }
              },

              textAlign: 'center'
            }}
          >
            {modalMessage}
          </Typography>

          {modalType === "Failed" && (
            <Button
              variant="contained"
              color="error"
              fullWidth
              sx={{ mt: 3, borderRadius: 2 }}
              onClick={() => setShowModal(false)}
            >
              Try Again
            </Button>
          )}
        </DialogContent>
      </Dialog>
      {dropboxMessage && (
        <Box
          sx={{
            position: "fixed",
            top: 20,
            right: 20,
            zIndex: 9999,
            minWidth: 250,
            p: 2,
            borderRadius: 2,
            boxShadow: 3,
            color: "#fff",
            fontWeight: 600,
            backgroundColor:
              dropboxType === "success"
                ? "green"
                : dropboxType === "error"
                  ? "red"
                  : "orange",
            animation: "fadeIn 0.3s ease-in-out",
          }}
        >
          {dropboxMessage}
        </Box>
      )}

      {/* Top Visitors Cards Section */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" gutterBottom sx={{ display: "flex", alignItems: "center", fontWeight: 600 }}>
          Dropbox Returns
          <IconButton onClick={fetchTopVisitors} sx={{ ml: 1, color: "primary.main" }}>
            <RefreshIcon />
          </IconButton>
          <FormControlLabel
            control={
              <Switch
                checked={isRealTime}
                onChange={(e) => setIsRealTime(e.target.checked)}
                color="primary"
              />
            }
            label="Real-time Updates"
            sx={{ ml: 2 }}
          />
        </Typography>

        {isLoading && topVisitors.length === 0 ? (
          <Box display="flex" justifyContent="center" alignItems="center" height={200}>
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={3}>
            {topVisitors.slice(0, 1).map((visitor, index) => (
              <Grid item xs={12} key={index}>
                <Card
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderRadius: 3,
                    boxShadow: 4,
                    overflow: "hidden",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: 8,
                    },
                    background: `linear-gradient(135deg, ${theme.palette.background.paper}, ${alpha(theme.palette.primary.light, 0.12)})`,
                  }}
                >
                  {/* LEFT SIDE - IMAGE */}
                  <Box
                    sx={{
                      minWidth: 180,
                      height: 180,
                      background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${alpha(theme.palette.primary.main, 0.7)})`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {visitor.member_photo ? (
                      <Avatar
                        src={formatBase64Image(visitor.member_photo)}
                        sx={{
                          width: 120,
                          height: 120,
                          border: `3px solid white`,
                          boxShadow: 3,
                        }}
                      />
                    ) : (
                      <Avatar
                        sx={{
                          width: 120,
                          height: 120,
                          bgcolor: "white",
                          border: `3px solid white`,
                          boxShadow: 3,
                        }}
                      >
                        <PersonIcon sx={{ fontSize: 60, color: theme.palette.primary.main }} />
                      </Avatar>
                    )}
                  </Box>

                  {/* MIDDLE - DETAILS */}
                  <CardContent sx={{ flex: 1, px: 3, py: 2 }}>
                    <Typography
                      gutterBottom
                      variant="h5"
                      component="h2"
                      fontWeight={700}
                      sx={{
                        color: theme.palette.text.primary,
                        textShadow: "0 1px 1px rgba(0,0,0,0.1)",
                      }}
                    >
                      {visitor.mname || "—"}
                    </Typography>

                    <Grid container spacing={1.5}>
                      <Grid item xs={12} sm={6} md={4}>
                        <Typography variant="body1" fontWeight={700} sx={{ fontSize: '1.12rem' }}>
                          <Box component="span" sx={{ color: theme.palette.primary.main }}>
                            ID:
                          </Box>{" "}
                          {visitor.mem_cd || "—"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <Typography variant="body1" fontWeight={700} sx={{ fontSize: '1.12rem' }}>
                          <Box component="span" sx={{ fontWeight: 700, color: theme.palette.primary.main }}>
                            Dept:
                          </Box>{" "}
                          {visitor.mem_dept || "—"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <Typography variant="body1" fontWeight={700} sx={{ fontSize: '1.12rem' }}>
                          <Box component="span" sx={{ fontWeight: 700, color: theme.palette.primary.main }}>
                            Program:
                          </Box>{" "}
                          {visitor.mem_degree || "—"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <Typography variant="body1" fontWeight={700} sx={{ fontSize: '1.12rem' }}>
                          <Box component="span" sx={{ fontWeight: 700, color: theme.palette.primary.main }}>
                            Category:
                          </Box>{" "}
                          {visitor.mem_ctgry || "—"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <Typography variant="body1" fontWeight={700} sx={{ fontSize: '1.12rem' }}>
                          <Box component="span" sx={{ fontWeight: 700, color: theme.palette.primary.main }}>
                            Acc. No:
                          </Box>{" "}
                          {visitor.accNo || "—"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <Typography variant="body1" fontWeight={700} sx={{ fontSize: '1.12rem' }}>
                          <Box component="span" sx={{ fontWeight: 700, color: theme.palette.primary.main }}>
                            Title:
                          </Box>{" "}
                          {visitor.title || "—"}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Box sx={{ mt: 2 }}>
                      <Chip
                        label={visitor.mem_type || "—"}
                        size="medium"
                        color="primary"
                        variant="filled"
                        sx={{
                          fontWeight: 600,
                          letterSpacing: 0.3,
                          px: 1.5,
                          boxShadow: 1,
                        }}
                      />
                    </Box>
                  </CardContent>

                  {/* RIGHT SIDE - BADGE */}
                  <Box sx={{ pr: 3 }}>
                    <Chip
                      label="Book Received"
                      color="success"
                      variant="filled"
                      sx={{
                        fontWeight: 700,
                        px: 2,
                        py: 1,
                        borderRadius: "12px",
                        fontSize: "0.9rem",
                        boxShadow: 2,
                      }}
                    />
                  </Box>
                </Card>
              </Grid>

            ))}
          </Grid>
        )}
      </Box>

      Filter Section
      {/* Collapsible Filter Section */}
      <Accordion
        defaultExpanded={false}
        sx={{
          mb: 3,
          borderRadius: 3,
          boxShadow: 2,
          '&:before': { display: 'none' } // Removes default divider
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="filter-content"
          id="filter-header"
          sx={{
            bgcolor: 'background.paper',
            borderRadius: 3,
            '&.Mui-expanded': {
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
            }
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            Filter Visitors
          </Typography>
        </AccordionSummary>

        <AccordionDetails sx={{ p: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <Autocomplete
                freeSolo
                options={memberCodeOptions}
                loading={memberCodeLoading}
                filterOptions={(options) => options.filter(option => option.value !== "-1")}
                onInputChange={(event, newInputValue) => {
                  handleInputChange({ target: { value: newInputValue } });
                }}
                onChange={(event, newValue) => {
                  if (newValue && typeof newValue !== 'string' && newValue.value !== "-1") {
                    handleFilterChange("mem_cd", newValue.value);
                  } else if (typeof newValue === 'string') {
                    handleFilterChange("mem_cd", newValue);
                  } else {
                    handleFilterChange("mem_cd", "");
                  }
                }}
                getOptionLabel={(option) =>
                  typeof option === 'string' ? option : option?.label || ""
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Member Code/Name"
                    size="small"
                    placeholder="Start typing member name or code"
                    value={filters.mem_cd}
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Receive Date"
                type="date"
                value={filters.recv_dt}
                onChange={(e) => handleFilterChange("recv_dt", e.target.value)}
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} container spacing={2} justifyContent="flex-end">
              <Grid item>
                <Button variant="outlined" onClick={resetFilters} sx={{ borderRadius: 2 }}>
                  Reset
                </Button>
              </Grid>
              <Grid item>
                <Button variant="contained" onClick={applyFilters} sx={{ borderRadius: 2 }}>
                  Apply Filters
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/* Data Grid Section */}
      <Paper sx={{ width: "100%", overflow: "hidden", borderRadius: 3, boxShadow: 2 }}>
        <Box sx={{ height: 400, width: "100%" }}>
          <DataGrid
            rows={filteredVisitors}
            columns={columns}
            loading={isLoading}
            pageSizeOptions={[5, 10, 25]}

            getRowClassName={(params) =>
              params.id === lastAddedId ? "new-row" : ""
            }

            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}
            slots={{
              toolbar: GridToolbar,
            }}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: theme.palette.primary.main,
                color: "white",
                fontSize: "1rem",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: 600,
              },
              "& .MuiDataGrid-cell": {
                borderBottom: `1px solid ${theme.palette.divider}`,
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: alpha(theme.palette.primary.main, 0.05),
              },
            }}
          />
        </Box>
      </Paper>

      {/* Visitor Detail Modal */}
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="visitor-detail-modal"
        aria-describedby="visitor-detail-description"
      >
        <Box sx={modalStyle}>
          {selectedVisitor && (
            <>
              <Typography id="visitor-detail-modal" variant="h5" component="h2" gutterBottom fontWeight={600} sx={{
                pb: 1,
                borderBottom: `2px solid ${theme.palette.primary.main}`,
                display: "flex",
                alignItems: "center"
              }}>
                <PersonIcon sx={{ mr: 1 }} /> Visitor Details
              </Typography>

              <Grid container spacing={3} sx={{ mt: 0.5 }}>
                <Grid item xs={12} md={4} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  {selectedVisitor.member_photo ? (
                    <Avatar
                      src={formatBase64Image(selectedVisitor.member_photo)}
                      sx={{ width: 200, height: 200, mb: 2, boxShadow: 3 }}
                    />
                  ) : (
                    <Avatar
                      sx={{
                        width: 200,
                        height: 200,
                        mb: 2,
                        bgcolor: theme.palette.primary.main,
                        boxShadow: 3
                      }}
                    >
                      <PersonIcon sx={{ fontSize: 80 }} />
                    </Avatar>
                  )}
                  <Chip
                    label={selectedVisitor.mem_type}
                    color="primary"
                    variant="filled"
                    sx={{ fontWeight: 500, fontSize: "1rem" }}
                  />
                </Grid>

                <Grid item xs={12} md={8}>
                  <Box sx={{
                    p: 2,
                    backgroundColor: alpha(theme.palette.primary.main, 0.05),
                    borderRadius: 2,
                    border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`
                  }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Typography><Box component="span" fontWeight={600}>Name:</Box> {selectedVisitor.mname}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography><Box component="span" fontWeight={600}>Member Code:</Box> {selectedVisitor.mem_cd}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography><Box component="span" fontWeight={600}>Mobile:</Box> {selectedVisitor.mobileNo}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography><Box component="span" fontWeight={600}>Department:</Box> {selectedVisitor.mem_dept}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography><Box component="span" fontWeight={600}>Program:</Box> {selectedVisitor.mem_degree}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography><Box component="span" fontWeight={600}>Category:</Box> {selectedVisitor.mem_ctgry}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography><Box component="span" fontWeight={600}>Accession No:</Box> {selectedVisitor.accNo}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography><Box component="span" fontWeight={600}>Title:</Box> {selectedVisitor.title}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography>
                          <Box component="span" fontWeight={600}>Issue Date:</Box>{" "}
                          {moment(selectedVisitor.iss_dt).format("DD/MM/YYYY HH:mm")}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography>
                          <Box component="span" fontWeight={600}>Receive Date:</Box>{" "}
                          {moment(selectedVisitor.recv_dt).format("DD/MM/YYYY HH:mm")}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
                <Button
                  variant="contained"
                  onClick={() => setModalOpen(false)}
                  sx={{ borderRadius: 2 }}
                >
                  Close
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Modal>
    </>
  );
}


















